import { render, staticRenderFns } from "./AppRadioButton.vue?vue&type=template&id=1aab6737"
import script from "./AppRadioButton.vue?vue&type=script&lang=js"
export * from "./AppRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports